import { MOUSEWHEEL } from '../utils/device'

/*
* Animated scroll to
*/
$.fn.scrollTo = function(target, baseDuration, distanceQuotient, easing, callback, direction) {
  /* Default values */
  if (typeof baseDuration == 'undefined') {
    baseDuration = 500
  }
  if (typeof distanceQuotient == 'undefined') {
    distanceQuotient = 4
  }
  if (typeof easing == 'undefined') {
    easing = 'swing'
  }
  if (typeof direction == 'undefined') {
    direction = 'vertical'
  }

  /* Get scrolling element only instead of 'html, body' */
  let scrollingElement = $(this)
  if (scrollingElement.length && (scrollingElement.first().is('html') || scrollingElement.first().is('body'))) {
    scrollingElement = $(document.scrollingElement || document.documentElement)
  }

  /* Scroll animated */
  let distance = Math.abs(target - $(this).scrollTop()),
  duration = baseDuration + distance / distanceQuotient
  if (direction == 'horizontal') {
    distance = Math.abs(target - $(this).scrollLeft())
    duration = baseDuration + distance / distanceQuotient
    scrollingElement.animate({'scrollLeft' : target}, duration, easing, callback)
  } else {
    scrollingElement.animate({'scrollTop' : target}, duration, easing, callback)
  }

  /* Allow breaking of scroll on mousewheel */
  scrollingElement.one(MOUSEWHEEL, function() {
    scrollingElement.stop()
  })

  return [distance, duration]
}
